import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Never fire GA events from localhost / dev environments
const IS_PROD = window.location.hostname !== 'localhost'
  && window.location.hostname !== '127.0.0.1';

/**
 * Component that tracks page views in Google Analytics.
 * Silently no-ops on localhost so dev sessions don't pollute GA4.
 */
const PageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (IS_PROD && window.gtag) {
      window.gtag('event', 'page_view', {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return null;
};

export default PageTracker;